import { SecondaryButton } from '../../../components';
import css from './Sections.module.css';
import Slider from 'react-slick';
import '../../../styles/slick/slick-theme.css';
import '../../../styles/slick/slick.css';
import { FormattedMessage } from 'react-intl';
import { ProductType, SliderSettings } from '../../../util/enums';

import newBoots from './bannerImages/optimised/newBoots.webp';
import usedBoots from './bannerImages/optimised/preOwned.webp';
import nikeBoots from './bannerImages/optimised/nikeBanner.webp';
import adidasBoots from './bannerImages/optimised/adidasBanner.webp';

const banners = [
  {
    id: 'LandingPage.shopBrandNewBoots',
    image: newBoots,
    filter: { pub_listingType: ProductType.NEW },
  },
  {
    id: 'LandingPage.shopUsedBoots',
    image: usedBoots,
    filter: { pub_listingType: ProductType.USED },
  },
  {
    id: 'LandingPage.shopNike',
    title: 'Shop Nike',
    image: nikeBoots,
    filter: { pub_brandname: 'has_any:nike' },
  },
  {
    id: 'LandingPage.shopAdidas',
    title: 'Shop Adidas',
    image: adidasBoots,
    filter: { pub_brandname: 'has_any:adidas' },
  },
];

const SectionBanners = ({ useHistoryPush }) => {
  return (
    <div className={css.bannerSec}>
      <div className={css.fixedWidthContainer}>
        <div className={css.contentSec}>
          <Slider {...SliderSettings}>
            {banners.map(({ id, title, image, filter }) => (
              <div key={id} className={css.bannerBlock}>
                <div className={css.bannerContent}>
                  <h3>{title || <FormattedMessage id={id} />}</h3>
                  <div className={css.buttonWrapper}>
                    <SecondaryButton
                      className={css.shopNowBtn}
                      onClick={() => useHistoryPush('SearchPage', filter)}
                    >
                      <FormattedMessage id="LandingPage.shopNow" />
                    </SecondaryButton>
                  </div>
                </div>
                <img src={image} alt="" />
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default SectionBanners;
